<template>
  <div class="spiag" :style="{ '--base-color': $theme.basecolor, '--base-dark': $theme.basedark, '--base-light': $theme.baselight }">
    <!-- -------------------------------------------- E R R O R E -------------------------------------------- -->
    <div v-if="errore" class="spiag-card shadow spiag-messaggio">
      <fa :icon="['fas', 'exclamation-triangle']" class="spiag-icona-grande" />
      <div>{{ t(errore) }}</div>
    </div>

    <!-- -------------------------------------------- G R A Z I E -------------------------------------------- -->
    <div v-else-if="fatta" class="spiag-card shadow spiag-messaggio">
      <fa :icon="['fas', fatta.stato === 'P' ? 'hourglass-half' : 'check-circle']" class="spiag-icona-grande" />
      <h2>{{ fatta.stato === "P" ? t("SPIA_GrazieAttesa") : t("SPIA_Grazie") }}</h2>
      <div class="spiag-riepilogo">
        <div>
          <span>{{ t("SPIA_Periodo") }}</span><b>{{ periodoLungo(fatta.dal, fatta.al) }}</b>
        </div>
        <div>
          <span>{{ t("SPIA_Giorni") }}</span><b>{{ fatta.giorni }}</b>
        </div>
        <div v-if="fatta.posti > 1">
          <span>{{ t("SPIA_Posti") }}</span><b>{{ fatta.posti }}</b>
        </div>
        <div>
          <span>{{ t("SPIA_Settore") }}</span><b>{{ fatta.settore }}</b>
        </div>
        <div v-if="fatta.fascia !== 'I'">
          <span>{{ t("SPIA_Fascia") }}</span><b>{{ t(fatta.fascia === "M" ? "SPIA_Mattina" : "SPIA_Pomeriggio") }}</b>
        </div>
        <div v-if="fatta.importo > 0">
          <span>{{ t("SPIA_Totale") }}</span><b>{{ prezzo(fatta.importo) }}</b>
        </div>
      </div>
      <p v-if="fatta.postiAssegnati" class="spiag-sub">{{ tv("SPIA_PostoAssegnato", { posti: fatta.postiAssegnati }) }}</p>
      <!-- Il link per annullare si promette solo se l'email lo contiene. -->
      <p v-if="emailInviata">{{ t(linkAnnulla ? "SPIA_EmailInviataLink" : "SPIA_EmailInviata") }}</p>
      <div class="spiag-btn" @click="ricomincia">{{ t("SPIA_Nuova") }}</div>
    </div>

    <template v-else-if="pronta">
      <!-- -------------------------------------------- Q U A N D O -------------------------------------------- -->
      <div ref="quando" class="spiag-card shadow">
        <h2 class="spiag-titolo"><fa :icon="['fas', 'umbrella-beach']" /> {{ t("SPIA_Titolo") }}</h2>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="nota" class="spiag-nota" v-html="nota" />
        <!-- Dal sito oggi non si prenota nessun giorno: lo si dice subito, invece
             di un calendario con tutti i giorni spenti. -->
        <div v-if="chiusoSito" class="spiag-avviso">{{ tv(chiusoSito.chiave, chiusoSito.valori) }}</div>
        <div v-else class="spiag-riga spiag-quando" :class="{ 'a-capo': stagionale }">
          <!-- Niente casella nativa: scriverebbe la data nel formato del browser.
               Qui si scrive e si legge solo gg/mm/aaaa, con le barre messe mentre
               si digita, e l'icona apre il calendario del Booking. -->
          <div class="spiag-campo spiag-campo-data">
            <span>{{ t("SPIA_Dal") }}</span>
            <span class="spiag-data">
              <input
                :value="dalTesto"
                type="text"
                inputmode="numeric"
                maxlength="10"
                size="10"
                :placeholder="t('SPIA_FormatoData')"
                @input="(e) => mascheraData(e, 'dal')"
                @blur="confermaData('dal')"
                @keyup.enter="confermaData('dal')"
              />
              <cyb-date-picker :value="dataITA(dal)" :lang="$store.lang" :disabled-dates="limitiData" @input="(val) => confermaData('dal', val)" />
            </span>
          </div>
          <div class="spiag-campo spiag-campo-data">
            <span>{{ t("SPIA_Al") }}</span>
            <span class="spiag-data">
              <input
                :value="alTesto"
                :disabled="alBloccato"
                type="text"
                inputmode="numeric"
                maxlength="10"
                size="10"
                :placeholder="t('SPIA_FormatoData')"
                @input="(e) => mascheraData(e, 'al')"
                @blur="confermaData('al')"
                @keyup.enter="confermaData('al')"
              />
              <cyb-date-picker
                :value="dataITA(al)"
                :lang="$store.lang"
                :disabled="alBloccato"
                :disabled-dates="limitiData"
                @input="(val) => confermaData('al', val)"
              />
            </span>
            <span v-if="alBloccato" class="spiag-sub">{{ t("SPIA_FinoAFineStagione") }}</span>
          </div>
          <label v-if="mezza" class="spiag-campo">
            <span>{{ t("SPIA_Fascia") }}</span>
            <select :value="fascia" @change="(e) => cambiaFascia(e.target.value)">
              <option value="I" :disabled="soloPomeriggioOggi">{{ t("SPIA_Intera") }}</option>
              <option value="M" :disabled="soloPomeriggioOggi">{{ t("SPIA_Mattina") }}{{ orari.mattina ? " (" + orari.mattina.da + " - " + orari.mattina.a + ")" : "" }}</option>
              <option value="P">{{ t("SPIA_Pomeriggio") }}{{ orari.pomeriggio ? " (" + orari.pomeriggio.da + " - " + orari.pomeriggio.a + ")" : "" }}</option>
            </select>
          </label>
          <label v-if="maxPosti > 1" class="spiag-campo stretto">
            <span>{{ t("SPIA_Posti") }}</span>
            <select :value="unita.length" @change="(e) => cambiaPosti(Number(e.target.value))">
              <option v-for="n in maxPosti" :key="n" :value="n">{{ n }}</option>
            </select>
          </label>
          <label v-if="stagionale" class="spiag-campo">
            <span>{{ t("SPIA_TipoPrenotazione") }}</span>
            <select :value="tipoPeriodo" @change="(e) => cambiaTipo(e.target.value)">
              <!-- "P": come al banco valgono settimana, quindicina e mese del listino. -->
              <option value="P">{{ t("SPIA_Periodo") }}</option>
              <option value="S">{{ t("SPIA_Stagionale") }}</option>
            </select>
          </label>
        </div>
        <div v-if="giorni > 0 && !chiusoSito" class="spiag-sub">{{ giorni === 1 ? t("SPIA_UnGiorno") : tv("SPIA_NGiorni", { n: giorni }) }}</div>
        <!-- Avvisi sempre in vista: date accorciate, posti presi nel frattempo,
             errori di caricamento. Il modulo dei dati può sparire, questo no. -->
        <div v-if="avviso.length || erroreCaricamento" class="spiag-avviso">
          <div v-for="m in avviso" :key="m">{{ tv(m, avvisoValori) }}</div>
          <div v-if="erroreCaricamento">{{ t(erroreCaricamento) }}</div>
        </div>
      </div>

      <!-- -------------------------------------------- S E T T O R I -------------------------------------------- -->
      <template v-if="chiusoSito" />
      <div v-else-if="caricamento" class="spiag-card shadow spiag-attesa"><fa :icon="['fas', 'spinner']" spin /></div>
      <div v-else-if="chiuso || fuoriPeriodo" class="spiag-card shadow spiag-messaggio">
        <fa :icon="['fas', 'calendar-times']" class="spiag-icona-grande" />
        <div v-for="m in avvisiPeriodo" :key="m">{{ tv(m, valoriPeriodo) }}</div>
        <div v-if="!avvisiPeriodo.length">{{ t(fuoriPeriodo ? "SPIA_FuoriStagione" : "SPIA_Chiuso") }}</div>
      </div>
      <!-- Dopo un errore di lettura non si mostrano i settori del periodo di prima:
           l'errore sta in cima. -->
      <template v-else-if="!erroreCaricamento">
        <div class="spiag-card shadow">
          <h3 class="spiag-sezione">{{ t("SPIA_Settori") }}</h3>
          <!-- Con più posti si sceglie un posto alla volta: la linguetta dice
               quale si sta scegliendo e che cosa hanno già gli altri. -->
          <template v-if="unita.length > 1">
            <div class="spiag-nota">{{ t("SPIA_PostiVicini") }}</div>
            <div class="spiag-linguette">
              <div v-for="(u, i) in unita" :key="i" class="spiag-linguetta" :class="{ attiva: i === attiva, vuota: !u.idsettore }" @click="attiva = i">
                <b>{{ nomePosto(i) }}</b>
                <span>{{ u.idsettore ? nomeSettore(u.idsettore) : "—" }}</span>
              </div>
            </div>
          </template>
          <!-- Il settore pieno si mostra spento e dice perché: nasconderlo
               farebbe pensare che non esista, e in alta stagione è
               l'informazione più utile della pagina. -->
          <div
            v-for="s in settori"
            :key="s.id"
            class="spiag-settore"
            :class="{ scelto: corrente.idsettore === s.id, pieno: !vendibile(s.id) }"
            @click="vendibile(s.id) && scegli(s)"
          >
            <img v-if="s.immagine" class="spiag-foto" :src="url(s.immagine)" :alt="s.nome" />
            <div v-else class="spiag-foto spiag-foto-finta" aria-hidden="true"><fa :icon="['fas', 'umbrella-beach']" /></div>
            <div class="spiag-settore-testo">
              <div class="spiag-settore-nome">{{ s.nome }}</div>
              <div class="spiag-settore-dati">
                <span v-if="s.lettini"><fa :icon="['fas', 'bed']" /> {{ s.lettini }} {{ t("SPIA_Lettini") }} {{ t("SPIA_Inclusi") }}</span>
                <span v-if="s.sdraio"><fa :icon="['fas', 'chair']" /> {{ s.sdraio }} {{ t("SPIA_Sdraio") }}</span>
                <span v-if="prezzoSettore(s.id) > 0"><fa :icon="['fas', 'euro-sign']" /> {{ prezzo(prezzoSettore(s.id)) }}</span>
              </div>
              <!-- Nel settore restano posti di un altro tipo, con un altro prezzo. -->
              <div v-if="prezzoVaria(s.id)" class="spiag-sub">{{ t("SPIA_PrezzoVaria") }}</div>
              <div v-if="s.descrizione" class="spiag-settore-desc">{{ s.descrizione }}</div>
              <div class="spiag-posti" :class="{ pieno: !vendibile(s.id), ultimo: vendibile(s.id) && restano(s.id) === 1 }">
                <!-- Senza tariffa (il listino non copre il periodo) dal sito non si vende. -->
                <template v-if="!senzaTariffa(s.id) && restano(s.id) === 0">{{ t("SPIA_Completo") }}</template>
                <template v-else-if="senzaTariffa(s.id)">{{ t("SPIA_ErrTariffa") }}</template>
                <template v-else-if="restano(s.id) === 1">{{ t("SPIA_UnLibero") }}</template>
                <template v-else>{{ t("SPIA_Liberi").replace("%{n}", restano(s.id)) }}</template>
              </div>
            </div>
          </div>
        </div>

        <!-- -------------------------------------------- E X T R A -------------------------------------------- -->
        <div v-if="corrente.idsettore && servizi.length" class="spiag-card shadow">
          <h3 class="spiag-sezione">{{ t("SPIA_Servizi") }}<template v-if="unita.length > 1"> · {{ nomePosto(attiva) }}</template></h3>
          <div v-for="s in servizi" :key="s.id" class="spiag-servizio">
            <div class="spiag-servizio-nome">
              {{ s.nome }}
              <span class="spiag-sub">{{ prezzo(s.prezzo) }}<span v-if="s.giornaliero"> {{ t("SPIA_AlGiorno") }}</span></span>
            </div>
            <div class="spiag-quantita">
              <button type="button" :disabled="quantita(s.id) === 0" @click="cambiaQuantita(s, -1)">−</button>
              <span>{{ quantita(s.id) }}</span>
              <button type="button" :disabled="s.quantitaMax > 0 && quantita(s.id) >= s.quantitaMax" @click="cambiaQuantita(s, 1)">+</button>
            </div>
          </div>
          <!-- Finiti i servizi di questo posto, si passa al prossimo da scegliere. -->
          <div v-if="prossimo >= 0" class="spiag-avanti" @click="attiva = prossimo">
            {{ nomePosto(prossimo) }} <fa :icon="['fas', 'chevron-right']" />
          </div>
        </div>
      </template>

      <!-- -------------------------------------------- C H I -------------------------------------------- -->
      <div v-if="tuttiScelti && !chiuso && !fuoriPeriodo && !chiusoSito && !erroreCaricamento" ref="dati" class="spiag-card shadow">
        <h2 class="spiag-titolo"><fa :icon="['fas', 'user']" /> {{ t("SPIA_Dati") }}</h2>
        <div class="spiag-scelta">
          {{ iniziale(periodoLungo(dal, al)) }} · {{ nomiSettori }} ·
          {{ fascia === "I" ? t("SPIA_Intera") : fascia === "M" ? t("SPIA_Mattina") : t("SPIA_Pomeriggio") }}
        </div>
        <div class="spiag-riga">
          <label class="spiag-campo largo" :class="{ 'spiag-err': errori.nome }">
            <span>{{ t("SPIA_Nome") }} *</span>
            <input v-model.trim="form.nome" type="text" maxlength="100" autocomplete="name" />
          </label>
          <label class="spiag-campo" :class="{ 'spiag-err': errori.telefono }">
            <span>{{ t("Tel") }} *</span>
            <input v-model.trim="form.telefono" type="tel" maxlength="30" autocomplete="tel" />
          </label>
          <label class="spiag-campo" :class="{ 'spiag-err': errori.email }">
            <span>{{ t("Email2") }} *</span>
            <input v-model.trim="form.email" type="email" maxlength="100" autocomplete="email" />
          </label>
        </div>
        <div class="spiag-riga">
          <label class="spiag-campo stretto">
            <span>{{ t("SPIA_Persone") }}</span>
            <input v-model.number="form.adulti" type="number" min="1" max="12" />
          </label>
          <label class="spiag-campo largo">
            <span>{{ t("SPIA_Note") }}</span>
            <textarea v-model="form.note" rows="2" maxlength="255" />
          </label>
        </div>
        <!-- Campo civetta: invisibile alle persone, i programmi lo riempiono. -->
        <input v-model="form.sito" type="text" name="sito" class="spiag-civetta" tabindex="-1" autocomplete="off" />

        <!-- Il totale lo calcola il gestionale: è lo stesso conto del banco. -->
        <div v-if="preventivo" class="spiag-totali">
          <div>
            <span>{{ t("SPIA_Totale") }}</span><b>{{ prezzo(preventivo.importo) }}</b>
          </div>
        </div>
        <div v-else-if="errorePreventivo.length" class="spiag-avviso">
          <div v-for="m in errorePreventivo" :key="m">{{ tv(m, valoriPreventivo) }}</div>
        </div>

        <div v-if="policy.length" class="spiag-policy">
          <div class="spiag-sub">
            <b>{{ t("SPIA_Policy") }}</b>
          </div>
          <div v-for="(p, i) in policy" :key="i" class="spiag-policy-testo">{{ p }}</div>
        </div>
        <div v-if="privacy" class="spiag-policy">
          <div class="spiag-sub">
            <b>{{ t("Privacy") }}</b>
          </div>
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div class="spiag-policy-testo" v-html="privacy" />
        </div>
        <label class="spiag-accetto" :class="{ 'spiag-err': errori.privacy }">
          <input v-model="form.privacy" type="checkbox" />
          {{ t("Accettare") }}
        </label>
        <div v-if="messaggi.length" class="spiag-avviso">
          <div v-for="m in messaggi" :key="m">{{ tv(m, valori) }}</div>
        </div>
        <!-- Si prenota solo con il totale dei dati di adesso: mentre si ricalcola
             il cliente non conferma un prezzo che non ha visto. -->
        <div class="spiag-btn" :class="{ disabilitato: invio || !inviabile }" @click="prenota">
          <fa v-if="invio" :icon="['fas', 'spinner']" spin />
          {{ t("SPIA_Prenota") }}
          <fa :icon="['fas', 'chevron-right']" />
        </div>
        <div class="spiag-sub spiag-centro">{{ t("Campiobbligatori") }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import apiService from "../services/api";
import paginaService from "../services/pagina";
import CybDatePicker from "../components/cybdatepicker.vue";

/** Lingua del Booking -> lingua del browser, per le date e i prezzi. */
const LOCALI = { ita: "it-IT", ing: "en-GB", eng: "en-GB", ted: "de-DE", fra: "fr-FR", spa: "es-ES", por: "pt-PT", jap: "ja-JP" };

/**
 * Errori che possono arrivare prima dei testi del gestionale (pagina aperta
 * senza struttura, gestionale che non risponde): in italiano, o in inglese per
 * le altre lingue, invece della chiave grezza.
 */
const TESTI_FISSI = {
  ita: {
    ERR_RPC: "Pagina aperta senza i dati della struttura: usi il link di prenotazione del sito dell'hotel.",
    ERR_GENERIC: "Si è verificato un errore: riprovi tra qualche minuto."
  },
  ing: {
    ERR_RPC: "This page was opened without the property details: please use the booking link on the hotel website.",
    ERR_GENERIC: "An error occurred: please try again in a few minutes."
  }
};

/**
 * Prenotazione online dello stabilimento balneare dell'hotel.
 *
 * Si apre come il Booking: /spiaggia?RPC_db=...&idhotel=...&lan=ita (o con gli
 * stessi dati in POST dal sito dell'hotel). Il cliente sceglie il periodo, la
 * fascia, quanti posti e per ognuno il SETTORE e i servizi extra; i posti li
 * assegna il gestionale, vicini quando stanno nello stesso settore.
 *
 * È la terza sorella delle pagine dei tavoli (ristorante.vue) e dei trattamenti
 * (spa.vue): stessa impaginazione e stesso giro di chiamate, con i settori al
 * posto del catalogo e un periodo al posto di un orario.
 */
export default {
  components: {
    CybDatePicker
  },
  data() {
    return {
      pronta: false,
      errore: "",
      testi: {},
      settori: [],
      servizi: [],
      disponibili: {},
      primo: "",
      ultimo: "",
      mezza: true,
      stagionale: false,
      maxGiorni: 0,
      maxPosti: 1,
      orari: {},
      nota: "",
      telefono: "",
      privacy: "",
      dal: "",
      al: "",
      // Le stesse date scritte all'italiana: sono quelle che si vedono e si digitano.
      dalTesto: "",
      alTesto: "",
      fascia: "I",
      // La fascia l'ha messa il sistema (oggi solo pomeriggio), non il cliente:
      // cambiando giorno torna la giornata intera.
      fasciaDiSistema: false,
      // Dal sito oggi non si prenota nessun giorno: { chiave, valori } dal gestionale.
      chiusoSito: null,
      // "P" e non "G": come al banco, valgono settimana, quindicina e mese del listino.
      tipoPeriodo: "P",
      // Ultimo giorno della stagione: l'abbonamento stagionale finisce lì.
      fineStagione: "",
      // L'"al" scelto prima di passare all'abbonamento, per ritrovarlo tornando indietro.
      alPrima: "",
      oggi: "",
      // Che cosa si vende ancora oggi: { finito, soloPomeriggio, proposta }.
      oggiFasce: {},
      // Un elemento per posto richiesto: il suo settore e i suoi servizi extra
      // (idservizio => quantità). "attiva" è quello che si sta scegliendo.
      unita: [{ idsettore: 0, extra: {} }],
      attiva: 0,
      chiuso: false,
      fuoriPeriodo: false,
      // Perché il periodo non si prenota (dal gestionale), con i valori dei segnaposto.
      avvisiPeriodo: [],
      valoriPeriodo: {},
      caricamento: false,
      preventivo: null,
      // I dati per cui è stato fatto il preventivo (vedi chiavePreventivo).
      preventivoChiave: "",
      // Servizi già riletti dopo un "servizio non più disponibile": una volta sola.
      serviziRiletti: false,
      // Disponibilità già riletta dopo un "posti presi" del preventivo, per questi dati.
      occupatoRiletto: "",
      // Giorni chiusi per il sito, che il calendario spegne: giorni della
      // settimana (0 = domenica) e chiusure straordinarie (date SQL).
      chiusiSettimana: [],
      chiusiDate: [],
      // L'invio ha risposto "tariffa mancante" per questi dati: Prenota resta
      // spento finché la scelta non cambia.
      bloccoTariffa: "",
      // L'invio ha risposto "troppe richieste": Prenota resta spento.
      troppe: false,
      errorePreventivo: [],
      valoriPreventivo: {},
      // Avvisi in cima, sempre visibili, e l'errore delle letture.
      avviso: [],
      avvisoValori: {},
      erroreCaricamento: "",
      // Numero dell'ultima richiesta: le risposte arrivate tardi si scartano.
      richiestaDisp: 0,
      richiestaPrev: 0,
      form: { nome: "", telefono: "", email: "", adulti: 2, note: "", privacy: false, sito: "" },
      errori: {},
      messaggi: [],
      valori: {},
      invio: false,
      fatta: null,
      emailInviata: false,
      linkAnnulla: false
    };
  },
  computed: {
    /** Giorni del periodo, estremi compresi: è quello che il cliente paga. */
    giorni() {
      if (!this.dal || !this.al) {
        return 0;
      }
      const a = this.giorno(this.dal);
      const b = this.giorno(this.al);
      return b < a ? 0 : Math.round((b - a) / 86400000) + 1;
    },
    corrente() {
      return this.unita[this.attiva] || this.unita[0];
    },
    /** Abbonamento stagionale: l'"al" è la fine della stagione e non si sceglie. */
    alBloccato() {
      return this.tipoPeriodo === "S" && !!this.fineStagione;
    },
    /** Oggi la mattina è finita: si vende solo il pomeriggio. */
    soloPomeriggioOggi() {
      return this.mezza && this.dal === this.oggi && !!this.oggiFasce.soloPomeriggio;
    },
    tuttiScelti() {
      return this.unita.every((u) => u.idsettore);
    },
    /** Il primo posto, dopo quello che si sta scegliendo, ancora senza settore. */
    prossimo() {
      const n = this.unita.length;
      for (let k = 1; k < n; k++) {
        const i = (this.attiva + k) % n;
        if (!this.unita[i].idsettore) {
          return i;
        }
      }
      return -1;
    },
    /** I settori scelti in una riga, come li scrive il gestionale: "Centrale × 2, Levante". */
    nomiSettori() {
      const quanti = {};
      const ordine = [];
      this.unita.forEach((u) => {
        if (!quanti[u.idsettore]) {
          quanti[u.idsettore] = 0;
          ordine.push(u.idsettore);
        }
        quanti[u.idsettore]++;
      });
      return ordine.map((id) => this.nomeSettore(id) + (quanti[id] > 1 ? " × " + quanti[id] : "")).join(", ");
    },
    /** Le condizioni dei settori scelti, ognuna una volta. */
    policy() {
      const out = [];
      this.unita.forEach((u) => {
        const s = this.settori.find((x) => x.id === u.idsettore);
        if (s && s.policy && !out.includes(s.policy)) {
          out.push(s.policy);
        }
      });
      return out;
    },
    /** I posti come li legge il gestionale: settore e servizi di ognuno. */
    richiesta() {
      return this.unita.map((u) => ({
        idsettore: u.idsettore,
        servizi: Object.keys(u.extra)
          .filter((k) => u.extra[k] > 0)
          .map((k) => ({ idservizio: Number(k), quantita: u.extra[k] }))
      }));
    },
    /** I dati da cui dipende il totale: un preventivo vale solo per questi. */
    chiavePreventivo() {
      return JSON.stringify([this.dal, this.al, this.fascia, this.tipoPeriodo, this.richiesta]);
    },
    /** C'è un totale valido per i dati di adesso, e niente da rileggere. */
    prenotabile() {
      return !!this.preventivo && this.preventivoChiave === this.chiavePreventivo && !this.caricamento;
    },
    /**
     * Si può premere Prenota: c'è il totale e l'invio non ha già risposto con un
     * errore che ripetere non cambia (tariffa mancante, troppe richieste).
     * Dopo un errore generico si può riprovare.
     */
    inviabile() {
      return this.prenotabile && !this.troppe && this.bloccoTariffa !== this.chiavePreventivo;
    },
    /**
     * Il calendario spegne i giorni fuori dalla finestra prenotabile e quelli
     * chiusi per il sito. vuejs-datepicker spegne i giorni prima di "to" e dopo
     * "from": l'ultimo giorno prenotabile è proprio "from".
     */
    limitiData() {
      const limiti = {};
      if (this.primo) {
        limiti.to = this.giorno(this.primo);
      }
      if (this.ultimo) {
        limiti.from = this.giorno(this.ultimo);
      }
      if (this.chiusiSettimana.length) {
        limiti.days = this.chiusiSettimana.slice();
      }
      if (this.chiusiDate.length) {
        limiti.dates = this.chiusiDate.map((d) => this.giorno(d));
      }
      return limiti;
    }
  },
  watch: {
    // Qualunque strada cambi i giorni, le caselle mostrano la data italiana.
    dal(sql) {
      this.dalTesto = this.dataITA(sql);
    },
    al(sql) {
      this.alTesto = this.dataITA(sql);
    },
    // Lingua cambiata dalla barra in alto: testi e settori nella nuova lingua.
    "$store.lang"(nuova, vecchia) {
      if (nuova && vecchia && nuova.toLowerCase() !== vecchia.toLowerCase()) {
        this.caricaConfigurazione();
      }
    }
  },
  mounted() {
    // Parametri come nel Booking: in POST dal sito dell'hotel o nell'indirizzo.
    const post = typeof this.$postData !== "undefined" && this.$postData && this.$postData.RPC_db ? this.$postData : null;
    const q = post || this.$route.query;
    this.$store.db = q.RPC_db || "";
    this.$store.idhotel = q.idhotel || "";
    this.$store.lang = (q.lan || "ita").toUpperCase();
    paginaService.neutra(this);
    if (!this.$store.db || !this.$store.idhotel) {
      this.errore = "ERR_RPC";
      return;
    }
    // Lingue della barra in alto.
    this.$root.$emit("lang:request", this.$store.lang);
    this.caricaConfigurazione();
  },
  methods: {
    t(chiave) {
      if (this.testi[chiave]) {
        return this.testi[chiave];
      }
      const fissi = TESTI_FISSI[this.lingua()] || TESTI_FISSI.ing;
      return fissi[chiave] || chiave;
    },
    /** Testo con i segnaposto (%{n}, %{data}, %{posti}) sostituiti. */
    tv(chiave, valori) {
      let testo = this.t(chiave);
      Object.keys(valori || {}).forEach((k) => {
        testo = testo.split("%{" + k + "}").join(String(valori[k]));
      });
      return testo;
    },
    iniziale(testo) {
      return testo ? testo.charAt(0).toUpperCase() + testo.slice(1) : "";
    },
    lingua() {
      return String(this.$store.lang || "ita").toLowerCase();
    },
    /** Indirizzo di un'immagine del backend (logo, sfondo, fotografie). */
    url(percorso) {
      const base = String(this.$config.server_url || "").replace(/\/rest\/?$/, "");
      return percorso ? base + "/" + percorso : "";
    },
    prezzo(valore) {
      return new Intl.NumberFormat(LOCALI[this.lingua()] || "it-IT", { style: "currency", currency: "EUR" }).format(valore);
    },
    liberi(idsettore) {
      const d = this.disponibili[idsettore];
      return d ? d.liberi : 0;
    },
    /** Liberi di un settore tolti quelli che gli altri posti richiesti vi hanno già preso. */
    restano(idsettore) {
      const presi = this.unita.filter((u, i) => i !== this.attiva && u.idsettore === idsettore).length;
      return Math.max(0, this.liberi(idsettore) - presi);
    },
    /** Il listino non copre il periodo per quel settore. */
    senzaTariffa(idsettore) {
      const d = this.disponibili[idsettore];
      return !!d && d.tariffa === false;
    },
    vendibile(idsettore) {
      return this.restano(idsettore) > 0 && !this.senzaTariffa(idsettore);
    },
    nomeSettore(idsettore) {
      const s = this.settori.find((x) => x.id === idsettore);
      return s ? s.nome : "";
    },
    nomePosto(i) {
      return this.t("SPIA_PostoN").replace("%{n}", i + 1);
    },
    prezzoVaria(idsettore) {
      const d = this.disponibili[idsettore];
      return !!d && !!d.varia && !this.senzaTariffa(idsettore);
    },
    /** Toglie dai posti i servizi extra che non sono più fra quelli proposti. */
    tieniServiziAttivi() {
      const attivi = {};
      this.servizi.forEach((s) => {
        attivi[s.id] = true;
      });
      this.unita.forEach((u) => {
        Object.keys(u.extra).forEach((k) => {
          if (!attivi[k]) {
            this.$delete(u.extra, k);
          }
        });
      });
    },
    /** L'avviso in cima riguarda la scelta di prima: cambiata la scelta, sparisce. */
    pulisciAvviso() {
      this.avviso = [];
      this.avvisoValori = {};
    },
    prezzoSettore(idsettore) {
      const d = this.disponibili[idsettore];
      return d ? d.prezzo : 0;
    },
    quantita(idservizio) {
      return this.corrente.extra[idservizio] || 0;
    },

    // ______________________ LETTURE ______________________

    caricaConfigurazione() {
      apiService
        .get("BE_spiaggia/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.lingua())
        .then((resp) => {
          this.testi = resp.testi || {};
          paginaService.applica(this, resp.grafica);
          this.settori = resp.settori || [];
          this.servizi = resp.servizi || [];
          this.primo = resp.primo;
          this.ultimo = resp.ultimo;
          this.fineStagione = resp.fineStagione || "";
          this.oggi = resp.oggi || "";
          this.oggiFasce = resp.oggiFasce || {};
          this.mezza = !!resp.mezza;
          this.stagionale = !!resp.stagionale;
          this.maxGiorni = resp.maxGiorni || 0;
          this.maxPosti = resp.maxPosti || 1;
          this.orari = resp.orari || {};
          this.nota = resp.nota || "";
          this.telefono = String(resp.telefono || "").trim();
          this.privacy = resp.privacy || "";
          this.chiusoSito = resp.chiusoSito || null;
          const chiusi = resp.chiusi || {};
          this.chiusiSettimana = (chiusi.settimana || []).map(Number);
          this.chiusiDate = chiusi.date || [];
          // Senza abbonamento in vendita (anche dopo un cambio di lingua) si torna al periodo.
          if (!this.stagionale && this.tipoPeriodo === "S") {
            this.tipoPeriodo = "P";
          }
          this.tieniServiziAttivi();
          if (!this.dal) {
            this.dal = this.primo;
            this.al = this.alBloccato ? this.fineStagione : this.primo;
            this.fasciaDiOggi();
          }
          this.pronta = true;
          if (!this.chiusoSito) {
            this.caricaDisponibilita();
          }
        })
        .catch((resp) => {
          this.testi = (resp && resp.testi) || this.testi;
          this.errore = (resp && resp.errori && resp.errori[0]) || "ERR_GENERIC";
        });
    },
    /**
     * Quanti posti restano libero per settore nel periodo scelto, e quanto costa.
     *
     * Il conto lo fa il gestionale: la regola del libero e quella del prezzo
     * stanno in un posto solo, e una pagina che se le calcolasse da sé prima o
     * poi offrirebbe un ombrellone che in spiaggia non c'è.
     */
    caricaDisponibilita() {
      // Il preventivo in viaggio è dei dati di prima: la sua risposta si scarta.
      ++this.richiestaPrev;
      this.preventivo = null;
      this.errorePreventivo = [];
      if (!this.dal || !this.al || this.giorni < 1) {
        return;
      }
      this.caricamento = true;
      // Solo l'ultima richiesta conta: cambiando date in fretta, una risposta
      // vecchia arrivata dopo mostrerebbe i posti di un altro periodo.
      const numero = ++this.richiestaDisp;
      const q =
        "?dal=" + this.dal + "&al=" + this.al + "&fascia=" + this.fascia + "&tipoPeriodo=" + this.tipoPeriodo;
      apiService
        .get("BE_spiaggia/disponibilita/" + this.$store.db + "/" + this.$store.idhotel + q)
        .then((resp) => {
          if (numero !== this.richiestaDisp) {
            return;
          }
          this.caricamento = false;
          this.erroreCaricamento = "";
          this.chiuso = !!resp.chiuso;
          this.fuoriPeriodo = !!resp.fuoriPeriodo;
          this.avvisiPeriodo = resp.avvisi || [];
          this.valoriPeriodo = resp.valori || {};
          if (resp.oggiFasce) {
            const primaSoloPomeriggio = !!this.oggiFasce.soloPomeriggio;
            this.oggiFasce = resp.oggiFasce;
            // La mattina può finire con la pagina aperta su oggi: la fascia
            // passa da sé al pomeriggio, e i posti si rileggono per quella.
            // Solo al passaggio: la fascia scelta dal cliente prima resta sua.
            const fascia = this.fascia;
            if (!primaSoloPomeriggio && this.oggiFasce.soloPomeriggio) {
              this.fasciaDiOggi();
            }
            if (this.fascia !== fascia) {
              this.caricaDisponibilita();
              return;
            }
          }
          // L'abbonamento finisce con la stagione: l'"al" lo decide il gestionale.
          if (this.tipoPeriodo === "S" && resp.al && resp.al !== this.al) {
            this.al = resp.al;
          }
          // Gli orari delle fasce nel giorno scelto: la settimana tipo dello
          // stabilimento li può cambiare da un giorno all'altro.
          if (resp.orari) {
            this.orari = resp.orari;
          }
          const mappa = {};
          (resp.settori || []).forEach((s) => {
            mappa[s.id] = s;
          });
          this.disponibili = mappa;
          // Periodo che non si prenota: il gestionale non manda i settori, e le
          // scelte restano com'erano, da rivalutare quando si torna a un
          // periodo prenotabile.
          if (this.chiuso || this.fuoriPeriodo) {
            this.preventivo = null;
            return;
          }
          // I posti che nel settore scelto non ci stanno più non restano scelti
          // (gli ultimi): il cliente deve rifare la scelta, non scoprirlo al
          // momento dell'invio.
          const presi = {};
          this.unita.forEach((u) => {
            if (u.idsettore) {
              presi[u.idsettore] = (presi[u.idsettore] || 0) + 1;
              if (presi[u.idsettore] > this.liberi(u.idsettore) || this.senzaTariffa(u.idsettore)) {
                u.idsettore = 0;
              }
            }
          });
          this.caricaPreventivo();
        })
        .catch((resp) => {
          if (numero !== this.richiestaDisp) {
            return;
          }
          this.caricamento = false;
          this.erroreCaricamento = (resp && resp.errori && resp.errori[0]) || "ERR_GENERIC";
          // Niente dati del periodo di prima: posti, prezzi e chiusure erano suoi.
          ++this.richiestaPrev;
          this.disponibili = {};
          this.preventivo = null;
          this.errorePreventivo = [];
          this.chiuso = false;
          this.fuoriPeriodo = false;
          this.avvisiPeriodo = [];
          this.valoriPeriodo = {};
        });
    },
    /** Il totale del periodo scelto, dal listino del gestionale. */
    caricaPreventivo() {
      const numero = ++this.richiestaPrev;
      const chiave = this.chiavePreventivo;
      this.errorePreventivo = [];
      if (!this.tuttiScelti) {
        this.preventivo = null;
        return;
      }
      const q =
        "?dal=" + this.dal + "&al=" + this.al + "&fascia=" + this.fascia + "&tipoPeriodo=" + this.tipoPeriodo +
        "&unita=" + this.base64url(JSON.stringify(this.richiesta));
      apiService
        .get("BE_spiaggia/preventivo/" + this.$store.db + "/" + this.$store.idhotel + q)
        .then((resp) => {
          if (numero !== this.richiestaPrev) {
            return;
          }
          this.preventivo = resp;
          this.preventivoChiave = chiave;
          this.serviziRiletti = false;
          this.occupatoRiletto = "";
          // Il massimo di un servizio si è abbassato: il totale è fatto sulle
          // quantità ridotte, che la pagina riprende e dice in cima.
          if (resp.ridotte && Array.isArray(resp.unita)) {
            this.riprendiQuantita(resp.unita);
            this.preventivoChiave = this.chiavePreventivo;
            this.avviso = ["SPIA_QuantitaRidotta"];
            this.avvisoValori = {};
            this.serviziRiletti = false;
            this.rileggiServizi(false);
          }
        })
        .catch((resp) => {
          if (numero !== this.richiestaPrev) {
            return;
          }
          // Il motivo si mostra: posti presi nel frattempo, tariffa mancante...
          this.preventivo = null;
          this.errorePreventivo = (resp && resp.errori) || ["ERR_GENERIC"];
          this.valoriPreventivo = (resp && resp.valori) || {};
          if (this.errorePreventivo.includes("SPIA_ErrServizio")) {
            this.rileggiServizi();
          } else if (this.errorePreventivo.includes("SPIA_ErrOccupato") && this.occupatoRiletto !== chiave) {
            // Posti presi nel frattempo: si rilegge la disponibilità, come
            // all'invio. Una volta per gli stessi dati: niente giri a vuoto.
            this.occupatoRiletto = chiave;
            this.caricaDisponibilita();
          }
        });
    },
    /** Le quantità dei servizi su cui il gestionale ha fatto il conto, posto per posto. */
    riprendiQuantita(righe) {
      righe.forEach((r, i) => {
        const u = this.unita[i];
        if (!u) {
          return;
        }
        const extra = {};
        (r.servizi || []).forEach((s) => {
          extra[s.idservizio] = Number(s.quantita) || 0;
        });
        Object.keys(u.extra).forEach((k) => {
          if (u.extra[k] > 0 && extra[k] !== u.extra[k]) {
            this.$set(u.extra, k, extra[k] || 0);
          }
        });
      });
    },
    /**
     * Un servizio extra scelto non è più online: si rileggono i servizi
     * proposti, si tolgono dai posti quelli spariti e si rifà il totale. Una
     * volta sola, finché un preventivo non torna buono: niente giri a vuoto.
     */
    rileggiServizi(preventivo = true) {
      if (this.serviziRiletti) {
        return;
      }
      this.serviziRiletti = true;
      apiService
        .get("BE_spiaggia/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.lingua())
        .then((resp) => {
          this.servizi = resp.servizi || [];
          this.tieniServiziAttivi();
          if (preventivo) {
            this.caricaPreventivo();
          }
        })
        .catch(() => {});
    },

    // ______________________ SCELTE ______________________

    /**
     * Settore del posto che si sta scegliendo. Senza servizi da proporre si passa
     * da sé al prossimo posto da scegliere; finiti i posti, ai dati.
     */
    scegli(settore) {
      this.pulisciAvviso();
      this.corrente.idsettore = settore.id;
      this.caricaPreventivo();
      if (!this.servizi.length && this.prossimo >= 0) {
        this.attiva = this.prossimo;
        return;
      }
      if (this.tuttiScelti) {
        this.$nextTick(() => this.$refs.dati && this.$refs.dati.scrollIntoView({ behavior: "smooth", block: "start" }));
      }
    },
    cambiaQuantita(servizio, passo) {
      const ora = this.quantita(servizio.id) + passo;
      const max = servizio.quantitaMax > 0 ? servizio.quantitaMax : 99;
      this.pulisciAvviso();
      this.$set(this.corrente.extra, servizio.id, Math.max(0, Math.min(max, ora)));
      this.caricaPreventivo();
    },
    /** Quanti posti: quelli in più nascono vuoti, quelli in meno si tolgono dal fondo. */
    cambiaPosti(n) {
      while (this.unita.length < n) {
        this.unita.push({ idsettore: 0, extra: {} });
      }
      this.unita.splice(n);
      this.attiva = Math.min(this.attiva, n - 1);
      this.pulisciAvviso();
      this.caricaPreventivo();
    },
    /**
     * Periodo o abbonamento stagionale. L'abbonamento va fino a fine stagione;
     * tornando al periodo si ritrova l'"al" di prima, se sta ancora nei limiti.
     */
    cambiaTipo(tipo) {
      if (tipo === this.tipoPeriodo) {
        return;
      }
      this.pulisciAvviso();
      if (tipo === "S") {
        this.alPrima = this.al;
        this.tipoPeriodo = "S";
        if (this.fineStagione) {
          this.al = this.fineStagione;
        }
      } else {
        this.tipoPeriodo = tipo;
        let al = this.alPrima && this.alPrima >= this.dal ? this.alPrima : this.dal;
        if (this.ultimo && al > this.ultimo) {
          al = this.dal;
        }
        this.al = al;
        this.accorcia();
      }
      this.caricaDisponibilita();
    },
    /**
     * Oggi, a mattina finita, si vende solo il pomeriggio; passata l'ora di
     * conversione del banco il pomeriggio si propone (fasciaProposta).
     */
    fasciaDiOggi() {
      if (!this.mezza) {
        return;
      }
      if (this.dal !== this.oggi) {
        // Il pomeriggio l'aveva messo il sistema per oggi: per un altro giorno
        // torna la giornata intera. Quello scelto dal cliente resta.
        if (this.fasciaDiSistema) {
          this.fascia = "I";
          this.fasciaDiSistema = false;
        }
        return;
      }
      if ((this.oggiFasce.soloPomeriggio || (this.oggiFasce.proposta === "P" && this.fascia === "I")) && this.fascia !== "P") {
        this.fascia = "P";
        this.fasciaDiSistema = true;
      }
    },
    /** Fascia scelta dal cliente: da qui in poi è sua, il sistema non la cambia più. */
    cambiaFascia(fascia) {
      this.fascia = fascia;
      this.fasciaDiSistema = false;
      this.pulisciAvviso();
      this.caricaDisponibilita();
    },
    /**
     * Oltre la durata massima si accorcia da sé, e si dice perché in cima, dove si
     * vede anche senza il modulo dei dati: lasciare scegliere un periodo che il
     * server rifiuterà è un giro a vuoto.
     */
    accorcia() {
      if (this.maxGiorni > 0 && this.giorni > this.maxGiorni && this.tipoPeriodo !== "S") {
        const fine = this.giorno(this.dal);
        fine.setDate(fine.getDate() + this.maxGiorni - 1);
        this.al = this.dataSQLdaDate(fine);
        this.avviso = ["SPIA_ErrTroppiGiorni"];
        this.avvisoValori = { n: this.maxGiorni };
      } else {
        this.avviso = [];
        this.avvisoValori = {};
      }
    },

    // ______________________ DATE ______________________

    /** Data SQL -> oggetto Date (mezzanotte locale). */
    giorno(sql) {
      const [a, m, g] = String(sql).split("-").map(Number);
      return new Date(a, m - 1, g);
    },
    /** Data SQL -> gg/mm/aaaa. */
    dataITA(sql) {
      const p = String(sql || "").split("-");
      return p.length === 3 ? p[2] + "/" + p[1] + "/" + p[0] : "";
    },
    /**
     * Oggetto Date -> data SQL.
     *
     * Non si usa toISOString(): quello converte in UTC, e sulle date a
     * mezzanotte locale restituirebbe il giorno prima.
     */
    dataSQLdaDate(d) {
      return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
    },
    /** gg/mm/aaaa -> data SQL, vuoto se non è un giorno vero. */
    dataSQL(testo) {
      const p = String(testo || "").match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (!p) {
        return "";
      }
      const g = Number(p[1]);
      const m = Number(p[2]);
      const a = Number(p[3]);
      const d = new Date(a, m - 1, g);
      if (d.getDate() !== g || d.getMonth() !== m - 1 || d.getFullYear() !== a) {
        return "";
      }
      return a + "-" + String(m).padStart(2, "0") + "-" + String(g).padStart(2, "0");
    },
    /** Mentre si scrive: solo cifre, con le barre al posto giusto. */
    mascheraData(e, quale) {
      const cifre = String(e.target.value).replace(/\D/g, "").slice(0, 8);
      let testo = cifre.slice(0, 2);
      if (cifre.length > 2) {
        testo += "/" + cifre.slice(2, 4);
      }
      if (cifre.length > 4) {
        testo += "/" + cifre.slice(4, 8);
      }
      this[quale + "Testo"] = testo;
      // La casella non è legata con v-model: il valore filtrato si riscrive a mano.
      e.target.value = testo;
    },
    /**
     * Data scritta a mano o scelta dal calendario: si accetta solo se è un giorno
     * vero dentro la finestra prenotabile, altrimenti torna quella di prima.
     *
     * "Al" prima di "dal" si raddrizza da sé invece di dare un errore: è quasi
     * sempre un ripensamento sul primo giorno, non un errore da segnalare.
     */
    /**
     * Testo in base64url, per la query string: il JSON in chiaro ("[]}]") fa
     * bloccare la richiesta da ModSecurity (caratteri non alfanumerici ripetuti).
     */
    base64url(testo) {
      const b = btoa(unescape(encodeURIComponent(testo)));
      return b.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    },
    confermaData(quale, valore) {
      // L'"al" dell'abbonamento è la fine della stagione: non si cambia.
      if (quale === "al" && this.alBloccato) {
        this.alTesto = this.dataITA(this.al);
        return;
      }
      const sql = this.dataSQL(valore === undefined ? this[quale + "Testo"] : valore);
      if (!sql || sql < this.primo || (this.ultimo && sql > this.ultimo)) {
        this[quale + "Testo"] = this.dataITA(this[quale]);
        return;
      }
      if (sql === this[quale]) {
        this[quale + "Testo"] = this.dataITA(sql);
        return;
      }
      this[quale] = sql;
      if (quale === "dal" && (!this.al || this.al < sql)) {
        this.al = sql;
      }
      if (quale === "al" && this.dal > sql) {
        this.dal = sql;
      }
      this.messaggi = [];
      this.accorcia();
      this.fasciaDiOggi();
      this.caricaDisponibilita();
    },
    /** Il periodo per esteso: un giorno solo si scrive una volta. */
    periodoLungo(dal, al) {
      if (!dal) {
        return "";
      }
      if (!al || al === dal) {
        return this.dataLunga(dal);
      }
      return this.dataLunga(dal) + " – " + this.dataLunga(al);
    },
    dataLunga(sql) {
      if (!sql) {
        return "";
      }
      const [a, m, g] = sql.split("-").map(Number);
      return new Date(a, m - 1, g).toLocaleDateString(LOCALI[this.lingua()] || "it-IT", { day: "numeric", month: "long", year: "numeric" });
    },

    // ______________________ INVIO ______________________

    prenota() {
      if (this.invio || !this.inviabile) {
        return;
      }
      this.invio = true;
      this.errori = {};
      this.messaggi = [];
      this.valori = {};
      this.avviso = [];
      apiService
        .post("BE_spiaggia/prenota/" + this.$store.db + "/" + this.$store.idhotel + "/" + this.lingua(), {
          ...this.form,
          dal: this.dal,
          al: this.al,
          fascia: this.fascia,
          tipoPeriodo: this.tipoPeriodo,
          unita: this.richiesta,
          // Il totale che il cliente ha visto: se nel frattempo è cambiato, il
          // gestionale non salva e lo dice.
          totale: this.preventivo.importo
        })
        .then((resp) => {
          this.invio = false;
          this.fatta = resp.prenotazione;
          this.emailInviata = !!resp.email;
          this.linkAnnulla = !!resp.linkAnnulla;
          window.scrollTo(0, 0);
        })
        .catch((resp) => {
          this.invio = false;
          this.errori = (resp && resp.errors) || {};
          const messaggi = (resp && resp.errori) || ["ERR_GENERIC"];
          const valori = (resp && resp.valori) || {};
          // Errori sui dati del cliente: restano accanto al modulo. Gli altri
          // (posti presi nel frattempo, periodo, tariffa) vanno in cima: il
          // modulo può sparire quando si rilegge la disponibilità.
          if (["nome", "telefono", "email", "privacy"].some((c) => this.errori[c])) {
            this.messaggi = messaggi;
            this.valori = valori;
          } else {
            this.avviso = messaggi;
            this.avvisoValori = valori;
            this.$nextTick(() => this.$refs.quando && this.$refs.quando.scrollIntoView({ behavior: "smooth", block: "start" }));
          }
          // I posti sono stati presi nel frattempo: si rilegge la disponibilità.
          if (messaggi.includes("SPIA_ErrOccupato") || messaggi.includes("SPIA_ErrSettore")) {
            this.caricaDisponibilita();
          } else if (messaggi.includes("SPIA_PrezzoCambiato")) {
            // Si mostra il totale nuovo: il cliente lo vede e conferma di nuovo.
            this.caricaDisponibilita();
          } else if (messaggi.includes("SPIA_ErrServizio") || messaggi.includes("SPIA_QuantitaRidotta")) {
            // Servizi cambiati: si rileggono e il preventivo riprende le quantità vere.
            this.serviziRiletti = false;
            this.rileggiServizi();
          } else if (messaggi.includes("SPIA_ErrTariffa")) {
            // Ripremere non cambia la tariffa: Prenota resta spento finché la
            // scelta (date, fascia, settori, servizi) è questa.
            this.bloccoTariffa = this.chiavePreventivo;
          } else if (messaggi.includes("SPIA_Troppe")) {
            // Il limite è per ora: ripremere non serve. Dopo un errore generico,
            // invece, si può riprovare.
            this.troppe = true;
          }
        });
    },
    ricomincia() {
      this.fatta = null;
      this.avviso = [];
      this.messaggi = [];
      this.unita = [{ idsettore: 0, extra: {} }];
      this.attiva = 0;
      this.preventivo = null;
      this.form = { nome: this.form.nome, telefono: this.form.telefono, email: this.form.email, adulti: this.form.adulti, note: "", privacy: false, sito: "" };
      this.caricaDisponibilita();
    }
  }
};
</script>

<style lang="scss">
@import "../css/variables.scss";

// Sotto la barra dell'hotel, come le altre pagine del Booking (.home, .rist, .spa).
.spiag {
  position: absolute;
  top: 7em;
  left: 0;
  right: 0;
  max-width: 860px;
  margin: 20px auto 40px;
  padding: 0 12px;
  text-align: left;
}
@media (max-width: 576px) {
  .spiag {
    top: 11em;
  }
}
.spiag-card {
  background: rgba(255, 255, 255, 0.96);
  border-radius: 10px;
  padding: 18px 20px;
  margin-bottom: 16px;
}
.spiag-titolo {
  font-size: 1.3em;
  font-weight: 600;
  color: var(--base-color);
  margin: 0 0 12px;
}
.spiag-sezione {
  font-size: 1.1em;
  font-weight: 600;
  color: var(--base-color);
  margin: 0 0 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.spiag-nota {
  background: #f6f7f9;
  border-left: 4px solid var(--base-color);
  padding: 8px 12px;
  margin-bottom: 12px;
  font-size: 0.9em;
}
.spiag-riga {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  align-items: flex-end;
}
.spiag-campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
  flex: 1 1 180px;
  margin-bottom: 8px;
  // Solo l'etichetta del campo: dentro c'e' anche il calendario, fatto di span.
  > span:not(.spiag-data) {
    font-size: 0.8em;
    font-weight: 600;
    color: $muted;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  input,
  select,
  textarea {
    border: 1px solid #d5d9e0;
    border-radius: 6px;
    padding: 8px 10px;
    font: inherit;
    color: $text;
    background: #fff;
  }
  // Data all'italiana: casella scrivibile e icona del calendario accanto. La
  // casella tiene a destra lo spazio dell'icona, che sta sopra il suo bordo.
  &.spiag-campo-data .spiag-data {
    position: relative;
    display: flex;
    align-items: center;
    input[type="text"] {
      flex: 1 1 auto;
      // Senza, una casella non scende mai sotto la sua misura e sborda sul campo accanto.
      min-width: 0;
      // Spazio per l'icona, che sta sopra il bordo destro della casella.
      padding-right: 30px;
      text-align: center;
    }
    // Del datepicker serve solo l'icona: la sua casella non si usa.
    .cyb-date-input input {
      display: none;
    }
    // L'icona si centra in altezza con il flex e non con transform: transform
    // apre un contesto di sovrapposizione, e il calendario, chiuso li' dentro,
    // finirebbe sotto i campi e le schede che vengono dopo.
    .vdp-datepicker {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 8px;
      display: flex;
      align-items: center;
    }
    .date-icon {
      margin: 0 !important;
      color: $muted;
      cursor: pointer;
    }
    // Il calendario: sopra tutto, appena sotto la casella e allineato al suo
    // bordo destro, a qualunque larghezza di schermo.
    .cyb-date-popup.vdp-datepicker__calendar {
      z-index: 1000;
      top: 100%;
      left: auto;
      right: -8px;
      margin-top: 4px;
      header {
        display: flex;
        align-items: center;
        // Il titolo cambia vista (mesi, anni) anche senza la lente.
        span:nth-of-type(2)::after {
          content: none;
        }
        // Frecce tonde come i pulsanti +/- dei servizi.
        .prev,
        .next {
          flex: 0 0 30px;
          width: 30px !important;
          height: 30px !important;
          margin: 0 6px;
          box-sizing: border-box;
          border-radius: 50%;
          &.disabled {
            opacity: 0.35;
          }
        }
      }
    }
  }
  &.largo {
    flex-basis: 100%;
  }
  &.stretto {
    min-width: 110px;
    flex: 0 1 110px;
  }
  &.spiag-err input,
  &.spiag-err textarea {
    border-color: $negative;
  }
}
// Date, fascia e posti su una riga sola: ognuno parte dalla misura del suo
// contenuto (le date da size="10") e lo spazio che avanza si divide fra tutti,
// cosi' la riga e' piena. Con il quinto campo, quello dei giorni, sugli schermi
// stretti non ci stanno: si va a capo e ogni riga resta piena. Sul telefono
// vanno a capo comunque, a tutta riga.
@media (min-width: 577px) {
  .spiag-quando {
    flex-wrap: nowrap;
    &.a-capo {
      flex-wrap: wrap;
    }
    .spiag-campo,
    .spiag-campo.stretto {
      flex: 1 1 auto;
      min-width: 0;
    }
  }
}

// Scheda di un settore: la fotografia a sinistra, il testo a destra.
.spiag-settore {
  display: flex;
  gap: 14px;
  padding: 14px 0;
  border-top: 1px solid #eef0f3;
  cursor: pointer;
  &:first-of-type {
    border-top: none;
    padding-top: 0;
  }
  // Scelto ha lo sfondo, e lo stacco torna su tutti i lati: anche il primo,
  // che senza sfondo non lo tiene in alto, altrimenti toccherebbe il bordo.
  &.scelto {
    background: var(--base-light);
    border-radius: 8px;
    padding: 14px 10px;
  }
  // Il settore pieno si vede ma non si tocca: nasconderlo farebbe pensare che
  // non esista.
  &.pieno {
    cursor: default;
    opacity: 0.55;
  }
}
.spiag-foto {
  width: 150px;
  height: 110px;
  object-fit: cover;
  border-radius: 8px;
  flex: 0 0 auto;
}
/**
 * Il posto della fotografia che manca: una sfumatura sfocata nei colori della
 * struttura, con il simbolo dell'ombrellone sopra. Lo sfocato sta in ::before,
 * altrimenti sfocherebbe anche il simbolo.
 */
.spiag-foto-finta {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8edf1;
}
.spiag-foto-finta::before {
  content: "";
  position: absolute;
  top: -20%;
  right: -20%;
  bottom: -20%;
  left: -20%;
  background: radial-gradient(circle at 28% 32%, var(--base-light, #d7e0e6), transparent 60%),
    radial-gradient(circle at 72% 72%, var(--base-color, #9bb0bd), transparent 55%), linear-gradient(135deg, #e3eaef 0%, #c6d2da 100%);
  filter: blur(14px);
}
.spiag-foto-finta svg {
  position: relative;
  font-size: 2.2em;
  color: #fff;
  opacity: 0.75;
}
.spiag-settore-testo {
  flex: 1 1 auto;
  min-width: 0;
}
.spiag-settore-nome {
  font-weight: 600;
  font-size: 1.05em;
}
.spiag-settore-dati {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 14px;
  margin: 4px 0;
  font-size: 0.9em;
  color: #4b5563;
  svg {
    color: var(--base-color);
  }
}
.spiag-settore-desc {
  font-size: 0.9em;
  margin-bottom: 8px;
  white-space: pre-line;
}
.spiag-posti {
  font-size: 0.85em;
  font-weight: 600;
  color: #15803d;
  &.ultimo {
    color: #b45309;
  }
  &.pieno {
    color: $negative;
  }
}
@media (max-width: 576px) {
  .spiag-settore {
    flex-direction: column;
  }
  .spiag-foto {
    width: 100%;
    height: 150px;
  }
}

// Linguette dei posti: quale si sta scegliendo, e il settore degli altri.
.spiag-linguette {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 14px;
}
.spiag-linguetta {
  display: flex;
  flex-direction: column;
  min-width: 110px;
  padding: 6px 12px;
  border: 2px solid #e3e6ea;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9em;
  span {
    color: #4b5563;
  }
  &.attiva {
    border-color: var(--base-color);
    background: var(--base-light);
  }
  &.vuota span {
    color: #9ca3af;
  }
}
.spiag-avanti {
  margin-top: 10px;
  text-align: right;
  font-weight: 600;
  color: var(--base-color);
  cursor: pointer;
}

// Servizi extra: nome a sinistra, contatore a destra.
.spiag-servizio {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-top: 1px solid #eef0f3;
  &:first-of-type {
    border-top: none;
  }
}
.spiag-servizio-nome {
  display: flex;
  flex-direction: column;
}
.spiag-quantita {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
  // Tondi sempre: misura fissa, niente imbottitura del browser e niente
  // restringimento quando il nome del servizio è lungo.
  button {
    flex: 0 0 30px;
    width: 30px;
    height: 30px;
    padding: 0;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    border-radius: 50%;
    border: 2px solid var(--base-color);
    background: #fff;
    color: var(--base-color);
    font-size: 1.1em;
    font-weight: 700;
    cursor: pointer;
    &:disabled {
      opacity: 0.35;
      cursor: default;
    }
  }
  span {
    min-width: 20px;
    text-align: center;
    font-weight: 600;
  }
}

.spiag-totali {
  margin: 12px 0;
  div {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 4px 0;
    border-bottom: 1px solid #eef0f3;
  }
  span {
    color: #6b7280;
  }
  b {
    font-size: 1.1em;
  }
}

.spiag-sub {
  font-size: 0.85em;
  color: #6b7280;
}
.spiag-centro {
  text-align: center;
  margin-top: 6px;
}
.spiag-attesa {
  padding: 16px;
  text-align: center;
  color: var(--base-color);
}
.spiag-scelta {
  font-weight: 600;
  margin-bottom: 12px;
}
.spiag-avviso {
  color: $negative;
  font-weight: 600;
  margin: 10px 0;
}
.spiag-policy {
  margin-top: 6px;
}
.spiag-policy-testo {
  max-height: 120px;
  overflow: auto;
  font-size: 0.75em;
  background: #f6f7f9;
  padding: 8px;
  border-radius: 6px;
  white-space: pre-wrap;
}
.spiag-accetto {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 10px 0;
  &.spiag-err {
    color: $negative;
    font-weight: 600;
  }
}
.spiag-civetta {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  opacity: 0;
}
.spiag-btn {
  background: var(--base-color);
  color: #fff;
  text-align: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  user-select: none;
  margin-top: 8px;
  &.disabilitato {
    opacity: 0.6;
    pointer-events: none;
  }
}
.spiag-messaggio {
  text-align: center;
  h2 {
    font-size: 1.3em;
    margin: 12px 0;
  }
}
.spiag-icona-grande {
  font-size: 2.6em;
  color: var(--base-color);
}
.spiag-riepilogo {
  display: inline-block;
  text-align: left;
  margin: 8px 0 12px;
  div {
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 3px 0;
    border-bottom: 1px solid #eef0f3;
  }
  span {
    color: #6b7280;
  }
  b::first-letter {
    text-transform: uppercase;
  }
}
</style>
